module.exports = __webpack_public_path__ + "img/logo-banner.9d4b0daa.png";